export const DASHA_HEADLINES = {
  en: { title: "Free Dasha", accent: "Calculator" },
  hi: { title: "दशा", accent: "कैलकुलेटर" },
} as const;
export function dashaHeadline(language: "en" | "hi") {
  const copy = DASHA_HEADLINES[language];
  return `${copy.title} ${copy.accent}`;
}
/* Interpretive reference copy only. Period lords, durations, and dates come
 * from KundaliResponse.dasha, which is computed by the canonical engine. */

export const DASHA_DETAILS: Record<string, { significations: string; nature: string }> = {
  Ketu: {
    significations: "Spirituality, detachment, past-life karma, mysticism, sudden changes",
    nature:
      "This period is associated with spiritual awakening, detachment from material pursuits, and resolution of past-life karmic patterns. Its expression depends on Ketu's condition in the birth chart.",
  },
  Venus: {
    significations: "Love, marriage, luxury, arts, beauty, comfort, vehicles, relationships",
    nature:
      "This period emphasizes relationships, comforts, artistic expression, and material priorities. Its results depend on Venus's placement, strength, and house ownership in the birth chart.",
  },
  Sun: {
    significations: "Authority, career, father, government, health, self-confidence, leadership",
    nature:
      "This period emphasizes authority, identity, recognition, and responsibility. Its results depend on the Sun's placement, strength, and house ownership in the birth chart.",
  },
  Moon: {
    significations: "Mind, emotions, mother, public life, travel, nurturing, intuition",
    nature:
      "This period emphasizes mind, emotions, care, home, and public connection. Its results depend on the Moon's placement, strength, and relationships in the birth chart.",
  },
  Mars: {
    significations: "Courage, energy, property, siblings, surgery, military, technology",
    nature:
      "This period emphasizes initiative, courage, competition, property, and physical effort. Its results depend on Mars's placement, strength, and house ownership in the birth chart.",
  },
  Rahu: {
    significations: "Foreign lands, technology, unconventional paths, obsession, sudden gains",
    nature:
      "This period emphasizes ambition, unfamiliar environments, technology, and unconventional paths. Its results depend on Rahu's sign, house, dispositor, and planetary associations.",
  },
  Jupiter: {
    significations: "Wisdom, children, education, dharma, wealth, expansion, teaching",
    nature:
      "This period emphasizes learning, dharma, guidance, children, and expansion. Its results depend on Jupiter's placement, strength, and house ownership in the birth chart.",
  },
  Saturn: {
    significations: "Discipline, karma, longevity, hard work, service, delays, justice",
    nature:
      "This period emphasizes duty, structure, patience, service, and sustained effort. Its results depend on Saturn's placement, strength, and house ownership in the birth chart.",
  },
  Mercury: {
    significations: "Intelligence, communication, business, writing, analysis, trade, education",
    nature:
      "This period emphasizes learning, communication, analysis, trade, and adaptability. Its results depend on Mercury's placement, strength, and planetary associations in the birth chart.",
  },
};

export function formatNakshatra(raw: string): string {
  return raw.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}
